// Framework and third-party non-UI
import React from 'react';

// Redux, contexts, and local helpers/utils/modules

// Component specific modules (Component-styled, etc.)

// App components

// Third-party components (buttons, icons, etc.)
import { CalciteModal } from '@esri/calcite-components-react';

export interface CalciteModalProps
  extends Omit<
    React.ComponentProps<typeof CalciteModal>,
    'onCalciteModalClose'
  > {
  onClose?: () => void;
}

const CalciteModalWrapper = ({
  closeButtonDisabled,
  escapeDisabled,
  onClose,
  open,
  outsideCloseDisabled,
  ...rest
}: CalciteModalProps) => {
  const onCalciteModalClose = (e: any) => onClose?.();

  return (
    <CalciteModal
      closeButtonDisabled={closeButtonDisabled || undefined}
      escapeDisabled={escapeDisabled || undefined}
      onCalciteModalClose={onCalciteModalClose}
      open={open || undefined}
      outsideCloseDisabled={outsideCloseDisabled || undefined}
      {...rest}
    />
  );
};

export default CalciteModalWrapper;
